





















































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { MapStore } from '@/store/map';
import TargomoService from '@/services/targomo.service';
import { StatisticValues } from '@targomo/core';
import { StatisticsResult } from '@targomo/core/typings/types/responses';
import { FilterStore } from '@/store/filter';

@Component
export default class WidgetRecruitmentPool extends Vue {
  @Prop({ required: true }) readonly isMobileDevice: boolean;

  records: any = [];
  filterStore = getModule(FilterStore, this.$store);
  mapStore = getModule(MapStore, this.$store);
  private hideRecruitmentPool = false;
  private hideJobs = false;

  filterData(field: string, data: StatisticsResult) {
    return Object.values(data.statistics).filter((el, id) => {
      if (Object.keys(data.statistics)[id] === field) return el;
    })[0].total;
  }

  @Watch('mapStore.travelType', { immediate: true, deep: true })
  onTravelTypeChange(travelType: any) {
    this.setData(travelType, this.mapStore.time, this.filterStore.lngLat);
  }

  @Watch('mapStore.time', { immediate: true, deep: true })
  onTimeChange(time: any) {
    this.setData(this.mapStore.travelType, time, this.filterStore.lngLat);
  }

  @Watch('filterStore.lngLat', { immediate: true, deep: true })
  onLngLatChange(lngLat: number[]) {
    this.setData(this.mapStore.travelType, this.mapStore.time, lngLat);
  }

  sumData() {
    const { selectedPopupEmploi } = this.mapStore;
    const data = [
      selectedPopupEmploi.Emploi_CC_AZ,
      selectedPopupEmploi.Emploi_CC_BE,
      selectedPopupEmploi.Emploi_CC_FZ,
      selectedPopupEmploi.Emploi_CC_GI,
      selectedPopupEmploi.Emploi_CC_JZ,
      selectedPopupEmploi.Emploi_CC_KZ,
      selectedPopupEmploi.Emploi_CC_LZ,
      selectedPopupEmploi.Emploi_CC_MN,
      selectedPopupEmploi.Emploi_CC_OQ,
      selectedPopupEmploi.Emploi_CC_RU
    ];
    let total = 0;
    data.forEach(el => {
      if (typeof el === 'number') {
        total += el;
      } else if (el.match(/\d/g)) {
        total += JSON.parse(el.match(/\d/g).join(''));
      }
    });
    return total;
  }

  setData(travelType: any, time: any, lngLat: number[]): void {
    if (lngLat) {
      this.mapStore.setLoading(true);
      this.$root.$emit('setPolygon');
      TargomoService.getData(lngLat, time, travelType).then(response => {
        const arr = Object.values(response[0].statistics)
          .filter((el, id) => {
            if (Object.keys(response[0].statistics)[id] !== 'Diploma') return el;
          })
          .reduce((a: StatisticValues, b: StatisticValues) => ({
            total: a.total + b.total,
            values: b.values
          }));
        const CapBepBepc = this.filterData('Cap/Bep', response[0]) + this.filterData('Bepc', response[0]);
        this.records = [
          { fields: { name: 'Population de 15 ans ou plus', value: arr.total }, id: 1 },
          { fields: { name: 'Pas ou peu diplômés', value: this.filterData('Diploma', response[0]) }, id: 2 },
          { fields: { name: 'Brevet des collèges/CAP/BEP', value: CapBepBepc }, id: 3 },
          { fields: { name: 'BAC', value: this.filterData('Bac', response[0]) }, id: 4 },
          { fields: { name: 'BAC +2', value: this.filterData('Bac +2', response[0]) }, id: 5 },
          { fields: { name: 'Bac +3/4', value: this.filterData('Bac +3/4', response[0]) }, id: 6 },
          { fields: { name: 'Bac +5', value: this.filterData('Bac +5', response[0]) }, id: 7 }
        ];
        this.mapStore.setLoading(false);
      });
    } else {
      this.records = [
        { fields: { name: 'Population de 15 ans ou plus', value: 143098 }, id: 1 },
        { fields: { name: 'Pas ou peu diplômés', value: 38469 }, id: 2 },
        { fields: { name: 'Brevet des collèges/CAP/BEP', value: 52475 }, id: 3 },
        { fields: { name: 'BAC', value: 24531 }, id: 4 },
        { fields: { name: 'BAC +2', value: 13824 }, id: 5 },
        { fields: { name: 'Bac +3/4', value: 8408 }, id: 6 },
        { fields: { name: 'Bac +5', value: 5391 }, id: 7 }
      ];
    }
  }
}

interface RecruitmentStatistic {
  name: string;
  value: number;
}
